// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'document-pdf';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.515 16.313a1.125 1.125 0 0 1-1.125 1.125H1.89a1.125 1.125 0 0 1-1.125-1.125V1.688A1.125 1.125 0 0 1 1.89.563h11.25a1.11 1.11 0 0 1 .787.322l2.25 2.16a1.116 1.116 0 0 1 .338.803z' />
    <path d='M4.252 3.412C2.58 4.5 4.792 7.297 7.74 9.195c.93.607 5.46 3.607 6.12 1.545.555-1.74-1.433-2.145-5.468-.885-5.047 1.575-5.25 4.702-3.75 5.04 1.995.457 2.378-4.02 2.483-4.89.33-3.165-1.05-7.755-2.873-6.593z' />
  </g>
);

export const viewBox = '0 0 18 18';
